/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Viewings_EmptyInputs */

const cs_viewings_empty = /** @type {(inputs: Viewings_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zatím žádné prohlídky.`)
};

const en_viewings_empty = /** @type {(inputs: Viewings_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No viewings yet.`)
};

/**
* | output |
* | --- |
* | "No viewings yet." |
*
* @param {Viewings_EmptyInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const viewings_empty = /** @type {((inputs?: Viewings_EmptyInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Viewings_EmptyInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_viewings_empty(inputs)
	return cs_viewings_empty(inputs)
});